import differenceInMinutes from 'date-fns/difference_in_minutes';
import { TIMEAGO_PREFIX } from '~shared/utils/constants';
import { BB_BETCARD_TIMEAGO_OPTIONS } from '../../constants';

export const translationFunction = (t) => (number, index) => {
    const prefix= TIMEAGO_PREFIX;
    const option = BB_BETCARD_TIMEAGO_OPTIONS[index];

    return [t(`${prefix}.${option}`), t(`${prefix}.${option}`)];
};

export const getScheduleStart = (selections) => {
    const selectionIds = Object.keys(selections);
    const now = new Date(Date.now());

    return selectionIds.reduce((mostRecent, id) => {
        const selection = selections[id];
        if(mostRecent) {
            const mostRecentDiff = differenceInMinutes(new Date(mostRecent), now);
            const selectionDiff = differenceInMinutes(new Date(selection.scheduled_start), now);
            if(mostRecentDiff > selectionDiff) {

                return selection.scheduled_start;
            }

            return mostRecent;
        }

        return selection.scheduled_start;
    }, null);
};
